import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function SinavStresiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['sinav-stresi-testi']} />;
}
